import { Component, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IncompleteRegistrationMonitorService } from '@mzic/mzic-services';
import posthog from 'posthog-js';

@Component({
  selector: 'mzic-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private _router: Router,
    private _renderer: Renderer2,
    private _incompleteRegistrationMonitor: IncompleteRegistrationMonitorService,
  ) {
    // Initialize browser close cleanup for incomplete registrations
    this._incompleteRegistrationMonitor.setupBrowserCloseCleanup();

    this._router.events.subscribe((events) => {
      if (events instanceof NavigationEnd) {
        posthog.capture('$pageview');

        if (events.url === '/' || events.url === '/home') {
          this._renderer.setStyle(document.body, 'background-color', '#ededed');
        } else {
          this._renderer.setStyle(document.body, 'background-color', '#111010');
        }
        if (events.url === '/') {
          this._router.navigate(['home']);
        }
      }
    });
  }
}
